<template>
  <div
    class="assignment-item"
    @click="input"
  >
    <field
      type="checkbox"
      :value="assigned"
      :collection="[{value: true}]"
      class="no-margin assignment-input"
      label="empty"
      :name="item.id.toString()"
      :params="{'no_i18n': true}"
      ref="input"
    />
    <label
      class="assignment-label"
    >
      {{ label }}
    </label>
  </div>
</template>
<script>
import Field from '@/components/helpers/DataInput/Field'
export default {
  props: {
    displayName: {
      // Which attribute to use for label
      type: String,
      required: true
    },
    item: {
      type: Object,
      required: true
    },
    assignedCollection: {
      type: Array,
      required: true
    }
  },
  computed: {
    assigned() {
      return this.assignedCollection.includes(this.item)
    },
    label() {
      return this.item[this.displayName]
    }
  },
  components: {
    Field
  },
  methods: {
    input(val) {
      // If outer div is clicked val will be a click object
      if (typeof val === 'object') {
        val = !this.$refs.input.value
      }
      this.$emit("input", this.item, val)
    }
  },
}
</script>
<style lang="sass" scoped>
.no-margin
  // This is bullshit
  margin-top: -12px !important

.assignment-input
  pointer-events: none

.assignment-label
  margin-left: 10px
  font-weight: 500
  cursor: pointer

.assignment-item
  display: flex
  align-items: center
  height: 60px
  border-bottom: 1px solid #b0b0b080
  cursor: pointer
  &:hover
    transition: all .15s ease-out
    background-color: $paper-lighter
</style>



// WEBPACK FOOTER //
// AssignmentModalElement.vue?0017e3a3